import { Stack } from "@mui/material";
import { type FC } from "react";
import { NavLink } from "react-router";

import { type SiteLink } from "~/constants/socials";

import * as Styled from "./FooterLinkColumn.styles";

interface IFooterLinkColumnProps {
  title: string;
  links: SiteLink[];
}

export const FooterLinkColumn: FC<IFooterLinkColumnProps> = ({
  title,
  links,
}) => {
  if (links.length === 0) {
    return null;
  }

  return (
    <Stack>
      <Styled.Heading component="p">{title}</Styled.Heading>
      {links.map(({ label, to, action, target }) => {
        if (action) {
          return (
            <Styled.LinkItem key={label} component="button" onClick={action}>
              {label}
            </Styled.LinkItem>
          );
        }

        return (
          <Styled.LinkItem
            key={label}
            component={NavLink}
            to={to}
            target={target}
            rel={target ? "noopener noreferrer" : undefined}
          >
            {label}
          </Styled.LinkItem>
        );
      })}
    </Stack>
  );
};
